import { getCart } from "@app/lib/cart";
import { dispatchCartUpdate } from "@app/utils/cart"

export const EVENT_CART_UPDATE = "cart:update";
export const EVENT_CART_MINI_OPEN = "drawer:mini-cart:open";

document.addEventListener("DOMContentLoaded", () => {
  init();
});

const init = async () => {
  const cart = await getCart();
  dispatchCartUpdate(cart)
};
